import { SuperUser } from './SuperUser';
import { InternalUser } from './InternalUser';
import { IntakeUser } from './IntakeUser';
import { OnboardProUser } from './OnboardProUser';
import { UHCInsightsUser } from './UHCInsightsUser';
import { CommonForm as CommonUserFormComponent } from './CommonForm';
import { PaperlessDeliveryUser } from './PaperlessDeliveryUser';
import { PaceAdmin } from './PaceAdmin';

export const routes = [
  {
    role: 'referral-intake-user',
    name: 'Referral Intake User',
    path: '/intake-user',
    component: IntakeUser,
  },
  {
    role: 'internal-user',
    name: 'Internal User',
    path: '/internal-user',
    component: InternalUser,
  },
  {
    role: 'super-user',
    name: 'Emulation User',
    path: '/super-user',
    component: SuperUser,
  },
  {
    role: 'pdo-admin-user',
    name: 'Paperless Delivery User',
    path: '/pdo-admin-user',
    component: PaperlessDeliveryUser,
  },
  {
    role: 'obp-user',
    name: 'Onboard Pro User',
    path: '/onboard-pro-user',
    component: OnboardProUser,
  },
  {
    toggle: 'UHC_INSIGHTS_EMULATION_USER',
    role: 'uhc-insights-user',
    name: 'UHC Insights User',
    path: '/uhc-insights-user',
    component: UHCInsightsUser,
  },
  {
    toggle: 'PSA_EMULATION_USER',
    role: 'provider-service-advocate-user',
    name: 'Provider Service Advocate User',
    path: '/provider-service-advocate-user',
    component: CommonUserFormComponent,
  },
  {
    toggle: 'PAAN_ADMIN_EMULATION_USER',
    role: 'paan-administrator-user',
    name: 'PAAN Administrator User',
    path: '/paan-administrator-user',
    component: CommonUserFormComponent,
  },
  {
    toggle: 'PACE_ADMIN',
    role: 'pace-admin',
    name: 'PACE Administrator User',
    path: '/pace-admin',
    component: PaceAdmin,
  },
];
